import { withErrorBoundary } from 'react-error-boundary';
import type { TypeButtonDetailed } from 'types/autogen/contentful';
import CMSLoginButton from 'components/CMS/components/Button/components/CMSLoginButton';
import CMSSignupButton from 'components/CMS/components/Button/components/CMSSignupButton';
import { navigationLinkToPageAction } from '../../shared/ContentfulHelpers';
import PageActionButton from 'components/Button/PageActionButton';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

function renderLinkButton(
    fields: TypeButtonDetailed['fields'],
    inspectorProps: ReturnType<typeof useContentfulInspectorMode>
) {
    const { variant, label, size, fullWidth, icon, iconPosition, link } = fields;
    const linkAction = navigationLinkToPageAction(link);
    const buttonProps = { variant, size, icon };
    const style = fullWidth ? { width: '100%' } : {};

    if (!linkAction)
        return !ContentfulLivePreview.initialized ? null : (
            <span style={{ color: 'red' }} {...inspectorProps({ fieldId: 'label' })}>
                Missing Link
            </span>
        );

    if (icon) {
        return (
            <PageActionButton.WithIcon
                style={style}
                action={linkAction}
                iconProperties={{ position: iconPosition }}
                {...buttonProps}
                {...inspectorProps({ fieldId: 'label' })}
            >
                {label}
            </PageActionButton.WithIcon>
        );
    }

    return (
        <PageActionButton style={style} action={linkAction} {...buttonProps} {...inspectorProps({ fieldId: 'label' })}>
            {label}
        </PageActionButton>
    );
}

function Button({ fields, sys }: TypeButtonDetailed) {
    const { type, variant, label, size, fullWidth } = fields;
    const { id } = sys;
    const buttonProps = { variant, size };
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    const style = fullWidth ? { width: '100%' } : {};

    if (type === 'Link') return renderLinkButton(fields, inspectorProps);
    if (type === 'Login')
        return (
            <CMSLoginButton style={style} {...buttonProps} {...inspectorProps({ fieldId: 'label' })}>
                {label}
            </CMSLoginButton>
        );
    if (type === 'Sign up')
        return (
            <CMSSignupButton style={style} {...buttonProps} {...inspectorProps({ fieldId: 'label' })}>
                {label}
            </CMSSignupButton>
        );

    return null;
}

export default withErrorBoundary(Button, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
